const canUseNotification = 'Notification' in window;

export const notify = (title: string, options?: NotificationOptions) => {
  if (!canUseNotification || Notification.permission === 'denied') {
    return;
  }
  const createNotification = () => new Notification(title, options);
  if (Notification.permission === 'granted') {
    createNotification();
  } else {
    Notification.requestPermission()
      .then((permission) => {
        if (permission === 'granted') {
          createNotification();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
};
